<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt">First published in Great Britain in 2020 by PEN &amp; SWORD TRANSPORT an imprint of Pen &amp; Sword Books Ltd</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire S70 2AS</p>
<p class="copy">Copyright © Pen &amp; Sword Books, 2020</p>
<p class="copy">Profile illustrations © David Bocquelet</p>
<p class="copy1">ISBN 9781526756848</p>
<p class="copy">eISBN 9781526756855</p>
<p class="copy">mobi ISBN 9781526756862</p>
<p class="copy1">The right of Lance Cole to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy1">A CIP record for this book is available from the British Library. All rights reserved.</p>
<p class="copy1">No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.</p>
<p class="copy1">Every reasonable effort has been made to trace copyright holders of material reproduced in this book, but if any have been inadvertently overlooked the publishers will be pleased to hear from them.</p>
<p class="copy1">Pen &amp; Sword Books Ltd incorporates the imprints of Pen &amp; Sword Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Social History, Transport, True Crime, Claymore Press, Frontline Books, Leo Cooper, Praetorian Press, Remember When, Seaforth Publishing and Wharncliffe.</p>
<p class="copy1">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy">Pen &amp; Sword Books Limited, 47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
<p class="copy1">Email: <span class="weblink"><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span> Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?38f05a74